import { Tooltip, Box } from "@mui/material";
import Zoom from "@mui/material/Zoom";

const CustomTooltip = ({ title, large, children }) => {
  return (
    <Tooltip
      title={title}
      arrow
      TransitionComponent={Zoom}
      PopperProps={{
        modifiers: [
          {
            name: "preventOverflow",
            options: { boundary: "window" },
          },
          {
            name: "offset",
            options: {
              offset: title === "Menu" ? [5, -8] : [3, -5],
            },
          },
        ],
      }}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: "white",
            color: "#101010",
            fontFamily: "Karla",
            fontSize: "0.7vw",
            fontWeight: 500,
            borderRadius: ".25vw",
            padding: ".4vw .6vw",
            letterSpacing: "-0.41px",
            lineHeight: "120%",
            maxWidth: "18vw",
            whiteSpace: "normal",
            overflowWrap: "break-word",
          },
        },
        arrow: {
          sx: {
            color: "white",
          },
        },
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        gap=".4vw"
        sx={{ cursor: "pointer" }}
      >
        {children}
      </Box>
    </Tooltip>
  );
};

export default CustomTooltip;
